import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-gradient-button',
  templateUrl: './gradient-button.component.html',
  styleUrls: ['./gradient-button.component.scss']
})
export class GrradientButtonComponent {

  @Input() label: string;
  @Input() isDisabled: boolean = false;
}
